import React, {Component, useEffect, useState} from 'react';
import './Register.css';
import { FaUserAlt, FaLock, FaEnvelope, FaUserLock, FaUserTie, FaUniversity, FaUpload } from "react-icons/fa";
import back from '../../assets/Group 1.svg';

import { useMutation } from '@apollo/client';
import { REGISTER_USER } from '../../queries'

const Register = () => {
  const [ register,{loading, error }] = useMutation(REGISTER_USER);

  const [errorLog, setErrorLog] = useState('');

    useEffect(()=>{
        console.log(error)
        if(error) {
            setErrorLog(error.message);

        }
    }, [error]);

  return (
    <RegisterForm register={register} errorLog={errorLog} loading={loading}/>
  )
}


class RegisterForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            username: '',
            schoolName: '',
            schoolType: '',
            pass: '',
            repass: '',
            errorForm: '',
            ktm: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        // this.handleValidation = this.handleValidation.bind(this);
    }

    handleValidation(){
        if (
            !this.state.email
            || !this.state.name
            || !this.state.username
            || !this.state.schoolName
            || !this.state.schoolType
            || !this.state.pass
            || !this.state.repass
            || this.state.ktm===null) {
                this.setState({
                    errorForm: "Form belum lengkap. Silakan isi."
                })
                return 0;
        }

        if(this.state.ktm.type !== "image/jpeg" &&
            this.state.ktm.type !== "application/pdf" &&
            this.state.ktm.type !== "image/png" &&
            this.state.ktm.type !== "application/x-zip-compressed"
            ){
            this.setState({
                errorForm: "Format File Masukan Salah",
            })
            return 0;
        }


        if(this.state.ktm.size > 1000000){
            this.setState({
                errorForm: "Besar file melebihi 1MB",
            })
            return 0;
        }

        if (this.state.pass !== this.state.repass){
            this.setState({
                errorForm: "Pengulangan Password harus sama",
            })
            return 0;
        }

        if (this.state.pass.length < 6){
            console.log(this.state.pass.length);
            this.setState({
                errorForm: "Panjang Password kurang dari 6 karakter",
            })
            return 0;
        }

        if (this.state.username.length < 6){
            this.setState({
                errorForm: "Panjang Username kurang dari 6 karakter",
            })
            return 0;
        }
        return 1;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    handleFileChange(event){
        this.setState({
            ktm: event.target.files[0]
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.handleValidation()){
            const o = { variables: {
                username: this.state.username,
                password: this.state.pass,
                name: this.state.name,
                email: this.state.email,
                schoolName: this.state.schoolName,
                schoolType: this.state.schoolType,
                identityPhotoFile: this.state.ktm,
              }};


              try {
                await this.props.register(o);
                alert("Silahkan cek email anda untuk verifikasi!");
                window.location = '/signin';
              }
                  catch (e) {
              }
        }

    }

    render() {
            console.log(this.state.errorForm)

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="container-fluid m-0 p-0">
                    <div className="signcontain">
                        <div className="row m-0 p-0 row1">
                            <div className="col-md-6 logcol p-0 m-0">
                                <div className="login-box">
                                    <h1>Register</h1>
                                    <h5 className = "ml-4">Gunakan email gmail untuk melakukan registrasi</h5>
                                    <div className="textbox">
                                        <FaEnvelope className="email"/>
                                        <input
                                            name="email"
                                            type="text"
                                            placeholder="Email"
                                            onChange={this.handleInputChange}
                                            value={this.state.email}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <FaUserTie className="name"/>
                                        <input
                                            name="name"
                                            type="text"
                                            placeholder="Nama Lengkap"
                                            onChange={this.handleInputChange}
                                            value={this.state.name}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <FaUserAlt className="username"/>
                                        <input
                                            name="username"
                                            type="text"
                                            placeholder="Username"
                                            onChange={this.handleInputChange}
                                            value={this.state.username}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <select
                                            name="schoolType"
                                            placeholder="School Type"
                                            onChange={this.handleInputChange}
                                            value={this.state.schoolType}>
                                                <option value="" disabled selected>Pilih Institusi</option>
""                                              <option value="UNIVERSITY">Universitas</option>
                                                <option value="HIGHSCHOOL">SMA</option>
                                        </select>
                                    </div>
                                    <div className="textbox">
                                        <FaUniversity className="schoolName"/>
                                        <input
                                            name="schoolName"
                                            type="text"
                                            placeholder="School Name"
                                            onChange={this.handleInputChange}
                                            value={this.state.schoolName}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <FaLock className="pass"/>
                                        <input
                                            name="pass"
                                            type="password"
                                            placeholder="Password"
                                            onChange={this.handleInputChange}
                                            value={this.state.pass}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <FaUserLock className="repass"/>
                                        <input
                                            name="repass"
                                            type="password"
                                            placeholder="Ulangi Password"
                                            onChange={this.handleInputChange}
                                            value={this.state.repass}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <h5>Masukkan Kartu Identitas (KTM Mahasiswa, Kartu Pelajar SMA)</h5>
                                        <h5 className="kecil">Format masukan : jpg, png, pdf, zip</h5>
                                        <h5 className="kecil">Max size : 1 MB</h5>
                                        <input
                                            name="upload"
                                            type="file"
                                            placeholder="Masukkan KTM"
                                            accept=".png,.jpg,.pdf"
                                            onChange={this.handleFileChange}

                                        />
                                    </div>
                                    {this.props.errorLog ?
                                        <p className="errorMsg">{this.props.errorLog}</p>:
                                    this.state.errorForm ?
                                        <p className="errorMsg">{this.state.errorForm}</p>:
                                        <></>
                                    }
                                    <button type="submit" disabled={this.props.loading} className="btn btnsign">Register</button>
                                    <div className="text">
                                        <p><span>Already have an account? </span> <br></br> <a href="/signin">Sign in</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 backg m-0 p-0">
                                <div className="background">
                                    <img src={back} alt="logo" className="logoback"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default Register;
